import { INVALID_RANGE, reviewFilters, reviewFiltersHeadings, SELECT_FIELD_DATE, TransferDateFieldEnum } from "@/utils/constants";
import { Checkbox, CheckboxGroup, Grid, GridItem, Stack, Text, Box, Button } from "@chakra-ui/react"
import { getHideUnnecessaryLOARejectionValue, getLOAApprovalFilterModel } from "../components/selector";
import { useDispatch } from "react-redux";
import { setHideUnnecessaryLOARejection, setLOAApprovalFilterModel } from "../ducks/slice";
import { CalendarDate } from '@internationalized/date';
import { DateValue } from "react-aria";
import { useEffect, useState } from "react";
import FlatDatePickr from "@/common/Flatpickr";

interface Props {
    item?: string;
}

export const LOAApprovalFilters = ({item = ""}: Props) => {
    const [transferDateError, setTransferDateError] = useState('');
    const dispatch = useDispatch();
    const loaApprovalFilterModel = getLOAApprovalFilterModel();
    const hideLOARejectionDocument = getHideUnnecessaryLOARejectionValue()

    const handleFilterValues = (value: string, isChecked: boolean, filterType: string) => {
        if(filterType === reviewFiltersHeadings.status){
            const updatedFilters = !isChecked ? 
                loaApprovalFilterModel.status.values.includes(value)
                    ? loaApprovalFilterModel.status.values
                        : [...loaApprovalFilterModel.status.values, value]
                            : loaApprovalFilterModel.status.values.filter((val) => val !== value)
            dispatch(setLOAApprovalFilterModel({
                ...loaApprovalFilterModel,
                status: {
                    ...loaApprovalFilterModel.status,
                    values: updatedFilters
                }
            }));
        } else if(filterType === reviewFiltersHeadings.faildSteps){
            const updatedFilters = !isChecked ? 
                loaApprovalFilterModel.faildSteps.values.includes(value)
                    ? loaApprovalFilterModel.faildSteps.values
                        : [...loaApprovalFilterModel.faildSteps.values, value]
                            : loaApprovalFilterModel.faildSteps.values.filter((val) => val !== value)
            dispatch(setLOAApprovalFilterModel({
                ...loaApprovalFilterModel,
                faildSteps: {
                    ...loaApprovalFilterModel.faildSteps,
                    values: updatedFilters
                }
            }));
        }else if(filterType === reviewFiltersHeadings.source){
            const updatedFilters = !isChecked ? 
                loaApprovalFilterModel.source.values.includes(value)
                    ? loaApprovalFilterModel.source.values
                        : [...loaApprovalFilterModel.source.values, value]
                            : loaApprovalFilterModel.source.values.filter((val) => val !== value)
            dispatch(setLOAApprovalFilterModel({
                ...loaApprovalFilterModel,
                source: {
                    ...loaApprovalFilterModel.source,
                    values: updatedFilters
                }
            }));
        }else if(filterType === reviewFiltersHeadings.storeType){
            const updatedFilters = !isChecked ? 
                loaApprovalFilterModel.storeType.values.includes(value)
                    ? loaApprovalFilterModel.storeType.values
                        : [...loaApprovalFilterModel.storeType.values, value]
                            : loaApprovalFilterModel.storeType.values.filter((val) => val !== value)
            dispatch(setLOAApprovalFilterModel({
                ...loaApprovalFilterModel,
                storeType: {
                    ...loaApprovalFilterModel.storeType,
                    values: updatedFilters
                }
            }));
        } else if (filterType === reviewFiltersHeadings.manualReview) {
            const updatedFilters = !isChecked ?
            loaApprovalFilterModel.isManuallyRequested.values.includes(value)
            ? loaApprovalFilterModel.isManuallyRequested.values
            : [...loaApprovalFilterModel.isManuallyRequested.values, value]
            : loaApprovalFilterModel.isManuallyRequested.values.filter((val:any) => val !== value)
            dispatch(setLOAApprovalFilterModel({
                ...loaApprovalFilterModel,
                isManuallyRequested: {
                    ...loaApprovalFilterModel.isManuallyRequested,
                    values: updatedFilters
                }
            }));
        }else if (filterType === reviewFiltersHeadings.additional) {
            dispatch(setHideUnnecessaryLOARejection(isChecked))
        }
    };

    const onDateChange = (fieldName: TransferDateFieldEnum, value: Date | null) => {
        if (!value) {
            return null;
        }
        
        const year = value.getFullYear();
        const month = value.getMonth() + 1; // Convert from 0-indexed to 1-indexed
        const day = value.getDate();
        const date = `${year}-${month}-${day}`;
        
        if (fieldName === TransferDateFieldEnum.dateFrom) {
            const today = new Date();
            const toDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
            
            dispatch(setLOAApprovalFilterModel({
                ...loaApprovalFilterModel,
                created_date_time: {
                    ...loaApprovalFilterModel.created_date_time,
                    [fieldName]: date,
                    [TransferDateFieldEnum.dateTo]: toDate
                }
            }));
        } else {
            dispatch(setLOAApprovalFilterModel({
                ...loaApprovalFilterModel,
                created_date_time: {
                    ...loaApprovalFilterModel.created_date_time,
                    [fieldName]: date
                }
            }));
        }
    };

    
    function setDateRange(dateFrom: Date, dateTo: Date) {
        dispatch(setLOAApprovalFilterModel({
            ...loaApprovalFilterModel,
            created_date_time: {
                ...loaApprovalFilterModel.created_date_time,
                dateFrom: `${dateFrom.getFullYear()}-${dateFrom.getMonth() + 1}-${dateFrom.getDate()}`,
                dateTo: `${dateTo.getFullYear()}-${dateTo.getMonth() + 1}-${dateTo.getDate()}`
            }
        }));
    }

    function handleTodayClick() {
        const today = new Date();
        setDateRange(today, today);
    }

    function handleThisWeekClick() {
        const today = new Date();
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() - today.getDay());
        setDateRange(firstDayOfWeek, today);
    }

    function handleThisMonthClick() {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        setDateRange(firstDayOfMonth, today);
    }

    const onResetTransferDate = () =>{
        dispatch(setLOAApprovalFilterModel({
            ...loaApprovalFilterModel,
            created_date_time: {
                ...loaApprovalFilterModel.created_date_time,
                dateFrom: null,
                dateTo: null
            }
        }));
    }

    useEffect(() => {
        if (
          loaApprovalFilterModel?.created_date_time?.dateFrom &&
          loaApprovalFilterModel?.created_date_time?.dateTo &&
          new Date(loaApprovalFilterModel?.created_date_time?.dateFrom) >
          new Date(loaApprovalFilterModel?.created_date_time?.dateTo)
        ) {
          setTransferDateError(INVALID_RANGE);
        } else {
          if (
            (!loaApprovalFilterModel?.created_date_time?.dateFrom &&
              !loaApprovalFilterModel?.created_date_time?.dateTo) ||
            (loaApprovalFilterModel?.created_date_time?.dateFrom &&
              loaApprovalFilterModel?.created_date_time?.dateTo)
          ) {
            setTransferDateError('');
          } else {
            setTransferDateError(
              SELECT_FIELD_DATE.replace(
                '{{field}}',
                !loaApprovalFilterModel?.created_date_time?.dateFrom ? 'start' : 'end'
              )
            );
          }
        }
    }, [JSON.stringify(loaApprovalFilterModel?.created_date_time)]);
    
    return <>
        <Grid
            templateRows='repeat(1, 1fr)'
            templateColumns='repeat(3, 300px)'
            gap={8}
            p={3}
            m={"20px 15px"}
            h={"max-content"}
            overflow={"auto"}
        >
            <GridItem>
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                    {reviewFiltersHeadings.status}
                </Text>
                <CheckboxGroup 
                    defaultValue={loaApprovalFilterModel.status.values}
                >
                    <Stack spacing={[4, 2]} direction={['column']}>
                        {
                            reviewFilters.status.map((val: any) => {
                                const isChecked = loaApprovalFilterModel.status.values.includes(val.value);
                                return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.status)}>{val.label}</Checkbox>;
                            })
                        }
                    </Stack>
                </CheckboxGroup> 
                <Grid mt={5}>
                    <GridItem>
                        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                            {reviewFiltersHeadings.source}
                        </Text>
                    <CheckboxGroup 
                        defaultValue={loaApprovalFilterModel.source.values}
                    >
                        <Stack spacing={[4, 2]} direction={['column']}>
                            {
                                reviewFilters.source.map((val: any) => {
                                    const isChecked = loaApprovalFilterModel.source.values.includes(val.value);
                                    return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.source)}>{val.label}</Checkbox>;
                                })
                            }
                        </Stack>
                    </CheckboxGroup>
                </GridItem>
                </Grid>
                <Grid mt={5}>
                    <GridItem>
                        <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                            {reviewFiltersHeadings.additional}
                        </Text>
                        <Stack spacing={[4, 2]} direction={['column']}>
                            {
                                reviewFilters.additional.map((val: any) => {
                                    const isChecked = hideLOARejectionDocument
                                    return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, e.target.checked, reviewFiltersHeadings.additional)}>{val.label}</Checkbox>;
                                })
                            }
                        </Stack>
                </GridItem>
                </Grid>
            </GridItem>
            <GridItem>
                <GridItem sx={{marginBottom: '1rem'}}>
                    <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                        {reviewFiltersHeadings.storeType}
                    </Text>
                    <CheckboxGroup 
                        defaultValue={loaApprovalFilterModel.storeType.values}
                    >
                        <Stack spacing={[4, 2]} direction={['column']}>
                            {
                                reviewFilters.storeType.map((val: any) => {
                                    const isChecked = loaApprovalFilterModel.storeType.values.includes(val.value);
                                    return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.storeType)}>{val.label}</Checkbox>;
                                })
                            }
                        </Stack>
                    </CheckboxGroup>
                </GridItem>
                <GridItem>
                    <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                        {reviewFiltersHeadings.manualReview}
                    </Text>
                    <CheckboxGroup
                        defaultValue={loaApprovalFilterModel?.isManuallyRequested?.values}
                    >
                        <Stack spacing={[4, 2]} direction={['column']}>
                                {
                                    reviewFilters.isManuallyRequested.map((val: any) => {
                                        const isChecked = loaApprovalFilterModel?.isManuallyRequested?.values.includes(val.value);
                                        return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.manualReview)}>{val.label}</Checkbox>;
                                    })
                                }
                            </Stack>
                        </CheckboxGroup>
                    </GridItem>
                <Grid mt={5}>
                    <GridItem>
                        <Box display={'flex'} alignItems={'end'} justifyContent={"space-between"}>
                            <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                                {reviewFiltersHeadings.uploadedAt}
                            </Text>
                            <Text fontSize={'14px'} color={'#0090c6'}>
                                <button onClick={onResetTransferDate}>
                                    Reset
                                </button>
                            </Text>
                        </Box>
                        <Text fontSize={'12px'} color={'red'} mb={3}>{transferDateError}</Text>
                        <Box display="flex" className="date-range-wrapper">
                            <div className="date-range-wrapper__item">
                                <FlatDatePickr label="From:" 
                                    onDateChange = {(value) => onDateChange(TransferDateFieldEnum.dateFrom, value)}
                                    value = {
                                        loaApprovalFilterModel.created_date_time && 
                                        loaApprovalFilterModel?.created_date_time?.dateFrom &&
                                        loaApprovalFilterModel?.created_date_time?.dateFrom !== 'null' ? 
                                        new CalendarDate(
                                            parseInt(loaApprovalFilterModel?.created_date_time?.dateFrom.split('-')[0] as string),
                                            parseInt(loaApprovalFilterModel?.created_date_time?.dateFrom.split('-')[1] as string),
                                            parseInt(loaApprovalFilterModel?.created_date_time?.dateFrom.split('-')[2] as string)
                                        ) : null
                                    }
                                    options={{
                                        timeZone : "America/New_York"
                                    }}
                                />
                            </div>
                            <div className="date-range-wrapper__item">
                                <FlatDatePickr label="To:" 
                                    onDateChange = {(value) => onDateChange(TransferDateFieldEnum.dateTo, value)}
                                    value = {
                                        loaApprovalFilterModel.created_date_time && 
                                        loaApprovalFilterModel?.created_date_time?.dateTo &&
                                        loaApprovalFilterModel?.created_date_time?.dateTo !== 'null' ? 
                                        new CalendarDate(
                                            parseInt(loaApprovalFilterModel?.created_date_time?.dateTo.split('-')[0] as string),
                                            parseInt(loaApprovalFilterModel?.created_date_time?.dateTo.split('-')[1] as string),
                                            parseInt(loaApprovalFilterModel?.created_date_time?.dateTo.split('-')[2] as string)
                                        ) : null
                                    }
                                    options={{
                                        timeZone : "America/New_York"
                                    }}
                                />
                            </div>
                            <Box className='flex-row' sx={{marginTop: '1rem'}}>
                                <Button
                                    className="refresh-btn-queue"
                                    onClick={handleTodayClick}
                                >
                                    Today
                                </Button>
                                <Button
                                    className="refresh-btn-queue"
                                    onClick={handleThisWeekClick}
                                >
                                    This Week
                                </Button>
                                <Button
                                    className="refresh-btn-queue"
                                    onClick={handleThisMonthClick}
                                >
                                    This Month
                                </Button>
                            </Box>
                        </Box>
                    </GridItem>
                </Grid>
            </GridItem>
            <GridItem>
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'} mb={4}>
                    {reviewFiltersHeadings.faildSteps}
                </Text>
                <CheckboxGroup 
                    defaultValue={loaApprovalFilterModel.faildSteps.values}
                >
                    <Stack spacing={[4, 2]} direction={['column']}>
                        {
                            reviewFilters.loaFailedSteps.map((val: any) => {
                                const isChecked = loaApprovalFilterModel.faildSteps.values.includes(val.value);
                                return <Checkbox value={val.value} isChecked={isChecked} onChange={(e: any) => handleFilterValues(val.value, isChecked, reviewFiltersHeadings.faildSteps)}>{val.label}</Checkbox>;
                            })
                        }
                    </Stack>
                </CheckboxGroup>
            </GridItem>
        </Grid>
    </>
}